module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "AddBackCardView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AddBackCardView!./src/pages/Shop/AddBackCard/index.js
// module id = 1802
// module chunks = 367